import { useState, useEffect } from "react";
import { makeStyles } from '@material-ui/core/styles';
import InventoryGalleryModel from "../../../model/InventoryGalleryModel";
import InventoryImage from "../../utils/InventoryImage";
import GalleryView from "./gallery/GalleryView";
import ServiceAPI from "../../../service/ServiceAPI";
import { Box, Button } from "@material-ui/core";
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';

const useStyles = makeStyles({
  container: {
    width: '300px',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  toolBar: {
    justifyContent: 'space-between'
  },
  actions: {
    display: 'flex',
    justifyContent: 'space-around',
    width: '100%'
  }
});

const ImageInputField = (props) => {
  const classes = useStyles();

  const [inventoryGallery, setInventoryGallery] = useState(null);
  const [isGalleryOverlayVisible, setIsGalleryOverlayVisible] = useState(false);

  useEffect(() => {
    if (props.inventoryGalleryId === null) {
      setInventoryGallery(null);
      return;
    }

    ServiceAPI.InventoryGallery().getImage(props.inventoryGalleryId).then((json) => {
      setInventoryGallery(new InventoryGalleryModel(json));
    });
  }, [props.inventoryGalleryId]);

  /**
   * Progate the selected image id back up the componet tree
   * and effect the API update.
   */
  const updateParentInventoryModel = (inventoryGalleryId) => {
    props.onChange({ 
      target: {
        getAttribute: () => { return "inventoryGalleryId"; },
        value: inventoryGalleryId
      }
    });

    props.onBlur({overideChangeFlag: true});
  }

  /**
   * 
   */
  const handleClick_openImageGallery = () => {
    setIsGalleryOverlayVisible(true);
  }

  /**
   * 
   */
  const handleChange_imageSelection = (galleryImage) => {
    setInventoryGallery(new InventoryGalleryModel(galleryImage));
    handleClose_galleryDialog();
    updateParentInventoryModel(galleryImage.id);
  }

  /**
   * 
   */
  const handleClick_removeImageGallery = () => {
    setInventoryGallery(null);
    updateParentInventoryModel(null);
  }

  /**
   * 
   */
  const handleClose_galleryDialog = () => {
    setIsGalleryOverlayVisible(false);
  }

  /**
   * 
   * @returns 
   */
  const renderInput = () => { 
    let btnText = inventoryGallery === null ? "Add Image" : "Change";

    return (
      <Box className={classes.actions}>
        <Button variant="contained" color="default" size="large" onClick={handleClick_openImageGallery}>{btnText}</Button>
        { inventoryGallery === null ? null : <Button variant="contained" color="default" size="large" onClick={handleClick_removeImageGallery}>Remove</Button> }
      </Box>
    ); 
  }

  /**
   * 
   */
  const renderGalleryOverlay = () => {
    if (!isGalleryOverlayVisible) {
      return null;
    }

    return (
      <Dialog fullScreen open={isGalleryOverlayVisible} onClose={ handleClose_galleryDialog }>
        <AppBar>
          <Toolbar className={classes.toolBar}> 
            <IconButton edge="start" color="inherit" onClick={ handleClose_galleryDialog } aria-label="close">
              <CloseIcon />
            </IconButton>
            <h3>Select Image from Gallery</h3>
            <Button autoFocus color="inherit" onClick={ handleClose_galleryDialog }>
              Done
            </Button>
          </Toolbar>
        </AppBar>
        <GalleryView handleClick_assignImageToInventory={ handleChange_imageSelection }/>
      </Dialog>
    );
  }

  return ( 
    <>
      <Box className={classes.container}>
        <InventoryImage 
          base64Image={inventoryGallery?.getImage()} 
          alt={inventoryGallery?.getDescription()} 
        />
        { renderInput() }
      </Box>
      { renderGalleryOverlay() }
    </>
  )
}

export default ImageInputField;
;